import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersonLeaveLimitSettingsService, leaveLimitMessage } from 'src/app/Service/Person/PersonLeaveLimitSettings.service';

@Component({
  selector: 'app-person-leave-limit-settings',
  templateUrl: './PersonLeaveLimitSettings.component.html',
  styleUrls: ['./PersonLeaveLimitSettings.component.scss']
})
export class PersonLeaveLimitSettingsComponent implements OnInit {
  loading = true;
  saving = false;
  error = '';
  saved = false;
  fields = [
    { key: 'hourlyMonthlyLimit', title: 'سقف مرخصی در ماه شمسی (ساعت)' },
    { key: 'hourlyYearlyLimit', title: 'سقف مرخصی در سال شمسی (ساعت)' },
    { key: 'dailyMonthlyLimit', title: 'سقف مرخصی در ماه شمسی (روز)' },
    { key: 'dailyYearlyLimit', title: 'سقف مرخصی در سال شمسی (روز)' }
  ];
  private control() {
    return new FormControl<number | null>(null, [Validators.min(0), Validators.max(99999999.99),
      Validators.pattern(/^\d+(\.\d{1,2})?$/)]);
  }
  form = new FormGroup({
    hourlyMonthlyLimit: this.control(), hourlyYearlyLimit: this.control(),
    dailyMonthlyLimit: this.control(), dailyYearlyLimit: this.control()
  });
  constructor(private service: PersonLeaveLimitSettingsService) { }
  ngOnInit() { this.load(); }
  load() {
    this.loading = true;
    this.error = '';
    this.service.get().subscribe({
      next: value => { this.form.patchValue(value); this.loading = false; },
      error: error => { this.error = leaveLimitMessage(error); this.loading = false; this.form.disable(); }
    });
  }
  save() {
    if (this.loading || this.saving || this.form.disabled || this.form.invalid) return;
    this.error = ''; this.saved = false; this.saving = true;
    this.service.put(this.form.getRawValue()).subscribe({
      next: value => { this.form.patchValue(value); this.saving = false; this.saved = true; },
      error: error => { this.error = leaveLimitMessage(error); this.saving = false; }
    });
  }
}
